<template>
  <section id="container">
        <header class="header white-bg sticky-top">
            <header-component
            :current-shift="currentShift"
            :current_user="current_user"
            @setStartedShift-event="setStartedShift"
            @setFinishedShift-event="setFinishedShift">
            </header-component>
        </header>
        <section id="main-content">
            <status-photos-component
            :photos_album="photos_album"
            :photos_avatar="photos_avatar"
            :current_user="current_user"
            :current_shift_owner="this.currentShiftOwner">
            </status-photos-component>
        </section>
        <common-fakes></common-fakes>
        <footer class="site-footer">
            <footer-component></footer-component>
        </footer>
    </section>
</template>

<script>
import Header from './site_include/HeaderComponent';
import Footer from './site_include/FooterComponent';
import StatusPhotosComponent from './users/StatusPhotosComponent';
import permissions from './mixins/permissions';
import axios from '../utils/axios';
import Swal from 'sweetalert2';
import CommonFakes from "./users/CommonFakes";

export default {
  mixins: [permissions],
  name: 'StatusPhotosMain',
  components: {
    'header-component': Header,
    'footer-component': Footer,
    'status-photos-component': StatusPhotosComponent,
    'common-fakes': CommonFakes,
  },
  data() {
    return {
      photos_avatar: [],
      photos_album: [],
      currentGetPhotosInterval: null,
      currentShift: {},
      checkingNewEvents: null,
      currentShiftInterval: null,
      ErrorInterval: null,
      baseUrl: '',
      urlRequest: {
        getUrlCurrentShift: '/api/v1/moder/get-current-shift',
        setUrlStartedShift: '/api/v1/moder/set-started-shift',
        setUrlFinishedShift: '/api/v1/moder/set-finished-shift',
      },
    };
  },
  computed: {
    currentShiftOwner() {
      return this.currentShift.owner;
    },
  },
  async mounted() {
    await this.getCurrentUser();
    if (this.current_user.admin_level <= 10) {
      await this.getCurrentShift();
      await this.setCurrentShiftInterval();
      this.setStartedShift();

    } else {
      this.setGetPhotosInterval();
      this.getEvents();
      this.setGetEventsInterval();
    }

  },
  methods: {
    setGetEventsInterval() {
      this.checkingNewEvents = setInterval(() => {
        this.getEvents();
    }, 20000);
    },
    getEvents() {
      this.$store.dispatch('getNewEvents');
    },
    error_alert(){
      if (this.photos_avatar.length !== 0 || this.photos_album.length !== 0){
        return;
      }
      return Swal.fire({
        icon: 'error',
        title: 'Что-то пошло не так...',
        text: 'Давно не было фото. ' +
              'Загрузите фотографию!',
      })
    },
    get_photos() {
      if (this.current_user.admin_level <= 10 && this.currentShiftOwner === false) {
        if (this.currentGetPhotosInterval !== null || this.checkingNewEvents !== null) {
          this.clearAllGetData()
        }
        this.setStartedShift()
      }

      const path = `/api/v1/status-photos/get_photos`;
      return axios.get(path)
        .then((response) => {
          this.photos_avatar = response.data.photos_avatar;
          this.photos_album = response.data.photos_album;

          if (response.data.photos_avatar.length === 0 && response.data.photos_album.length === 0 && this.ErrorInterval == null){
            this.ErrorInterval = setTimeout(() => {
              this.error_alert();
            }, 900000)
          } else if ((response.data.photos_avatar.length !== 0 || response.data.photos_album.length !== 0) && this.ErrorInterval != null){
            Swal.close();
            clearTimeout(this.ErrorInterval);
            this.ErrorInterval = null;
          }
        })
        .catch((error) => {
          // eslint-отключение следующей строки
          console.error(error);
        });
    },
    setGetPhotosInterval() {
      this.currentGetPhotosInterval = setInterval(() => {
        this.get_photos();
      }, 5000);
    },
    /* начать смену */
    getCurrentShift() {
      return axios.get(this.urlRequest.getUrlCurrentShift)
        .then((response) => {
          if (response.hasOwnProperty('data')) {
            this.currentShift = response.data;
          } else {
            this.currentShift = false;
          }
        })
        .catch((error) => {
          console.log(JSON.parse(JSON.stringify(error)));
        });
    },
    /* периодическое обновление информации о текущей смене */
    setCurrentShiftInterval() {
      this.currentShiftInterval = setInterval(() => {
        this.getCurrentShift();
      }, 30000);
    },
    /* проверка смены модератора (его смена или нет) */
    checkCurrentShiftOwner() {
      return (this.current_user.admin_level === 10 && this.currentShiftOwner === true);
    },
    /* начать смену */
    setStartedShift() {
      if (this.checkCurrentShiftOwner()) {
        this.setGetPhotosInterval();
        this.getEvents();
        this.setGetEventsInterval();
      }

      if (this.current_user.admin_level > 10 || this.currentShiftOwner === true) {
        // this.setGetPhotosInterval();
        return false;
      }

      let msg = {};
      if (this.currentShift.admin_id !== null) {
        msg = {
          title: 'Для проверки фотографий необходимо завершить смену другого модератора',
          text: `Сейчас идет смена модератора: ${this.currentShift.admin_name}. Завершить его смену и начать свою?`,
        };
      } else {
        msg = {
          title: 'Для проверки фотографий необходимо начать свою смену',
          text: '',
        };
      }

      Swal.fire({
        title: msg.title,
        text: msg.text,
        type: 'warning',
        showCloseButton: true,
        showCancelButton: true,
        focusCancel: true,
        confirmButtonText: 'Начать смену',
        cancelButtonText: 'Отмена',
      }).then((result) => {
        if (result.value) {
          return axios.post(this.urlRequest.setUrlStartedShift)
            .then(() => {
              this.getCurrentShift();
              this.setGetPhotosInterval();
              this.setGetEventsInterval();
            })
            .catch((error) => {
              console.log(JSON.parse(JSON.stringify(error)));

              return Swal.fire({
                type: 'error',
                title: 'Ошибка сервера!',
              });
            });
        }
      });
    },
    clearAllGetData() {
      clearInterval(this.currentGetPhotosInterval);
      clearInterval(this.checkingNewEvents);
      this.currentGetPhotosInterval = null;
      this.checkingNewEvents = null;
      this.$store.dispatch('setEvents', []);
    },
    /* закончить смену */
    setFinishedShift() {
      if (this.current_user.admin_level > 10 || this.currentShiftOwner !== true) {
        return false;
      }

      Swal.fire({
        title: 'Завершить свою смену?',
        type: 'question',
        showCloseButton: true,
        showCancelButton: true,
        focusCancel: true,
        confirmButtonText: 'Завершить смену',
        cancelButtonText: 'Отмена',
      }).then((result) => {
        if (result.value) {
          return axios.post(this.urlRequest.setUrlFinishedShift)
            .then(() => {
              this.clearAllGetData();
              this.getCurrentShift();
            })
            .catch((error) => {
              console.log(JSON.parse(JSON.stringify(error)));

              return Swal.fire({
                type: 'error',
                title: 'Ошибка сервера!',
              });
            });
        }
      });
    },
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/StatusPhotosMain.vue